import React, { useState } from 'react';
import './contactme.css';

const ContactMe = () => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [activeCard, setActiveCard] = useState('linkedin');

  const handleCardToggle = (id) => {
    if (!isAnimating) {
      setIsAnimating(true);

      setActiveCard(id);
      setTimeout(() => {
        setIsAnimating(false);
      }, 1000); // Adjust the timeout value to match the transition time in your CSS
    }
  };

  return (
    <div className='cards'>
      <div
        className={`card ${activeCard === 'linkedin' ? 'active' : ''}`}
        id='linkedin'
      >
        <a className='card-toggle' onClick={() => handleCardToggle('linkedin')}>
          <i>
            <span className='fa fa-linkedin'>
              {' '}
              <img src='assets/linkedin.svg' alt='' />
            </span>
          </i>
        </a>
        <div className='card-content'>
          <div className='row'>
            <h2>
              My <strong>LinkedIn</strong>
            </h2>

            <div>
              <a
                href='https://www.linkedin.com/in/mike-rambil?trk=profile-badge'
                target='_blank'
                rel='noreferrer'
                className='linkedin_caller-button'
              >
                Visit Profile
              </a>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`card ${activeCard === 'behance' ? 'active' : ''}`}
        id='behance'
      >
        <a className='card-toggle' onClick={() => handleCardToggle('behance')}>
          <i>
            <span className='fa fa-behance'>
              {' '}
              <img src='assets/arr-up.svg' alt='' />
            </span>
          </i>
        </a>
        <div className='card-content '>
          <div className='row'>
            <div className='card-content-main-title'>
              <h2 style={{ color: '#fff' }}>
                My <strong>Personal Card</strong>
              </h2>
            </div>
            <div className='button_template_custom'>
              <a
                href='tel:+16305508561'
                className=' hover-underline-animation anime-grad telephone-footer '
              >
                630-550-8561
              </a>
            </div>

            <h3
              className='footer-column copy smallcopyhead_email'
              data-aos='flip-up'
              data-aos-duration='300ms'
            >
              <a
                className='chonky-underline-violet has-hover-anim snipcss-4jxlJ style-HyoFo'
                href='mailto: mikerambil@gmail.com'
                id='style-HyoFo'
              >
                mikerambil@gmail.com
              </a>
            </h3>
          </div>
        </div>
      </div>

      {/* 
        The third card is commented out in your code snippet.
        If you uncomment it, make sure to provide proper closing tags as well.
      */}
      {/* 
      <div
        className={`card ${activeCard === 'twitter' ? 'active' : ''}`}
        id='twitter'
      >
        <a className='card-toggle' onClick={() => handleCardToggle('twitter')}>
          <i>
            <span className='fa fa-twitter'>
              {' '}
              <img src='assets/twitter.svg' alt='' />
            </span>
          </i>
        </a>
        <div className='card-content'>
          <div className='row'>
            <h2>
              My <strong>Twitter</strong>
            </h2>
            <p>
              Fugit veniam, animi architecto doloribus veritatis vitae sint
              doloremqu amet hic repellat officiis nam quos vel doloremque
              praesentium.
            </p>
          </div>
          <div className='right col'>
            <img
              src='https://dl.dropboxusercontent.com/u/26808427/cdn/preview.jpg'
              alt=''
            />
          </div>
        </div>
        <div className='contact'>Contact Me</div>
      </div> 
      */}
    </div>
  );
};

export default ContactMe;
